export default "__VITE_ASSET__Bu$N6wfe__"